/**
 * 内容文案韩译表（中文原文 → 한국어）。规则同 CONTENT_EN。
 */
export const CONTENT_KO = {
  '永远元气满满的乐天派，用漫天弹幕把快乐撒向全屏。': '언제나 씩씩한 낙천가, 탄막과 함께 기쁨을 화면 가득 뿌린다.',
  '戴着墨镜的冷酷射手，弹无虚发，人狠话不多。': '선글라스의 냉정한 명사수. 백발백중, 말은 적다.',
  '一点就着的暴脾气，火球所到之処寸草不生。': '성질 급한 폭발 직전의 성격. 화염구가 지나간 자리엔 풀도 남지 않는다.',
  '爱哭的软妹子，眼泪会自己找到敌人，护盾悄悄守护她。': '울보 소녀. 눈물은 스스로 적을 찾아가고, 실드가 조용히 지켜준다.',
  '满脸问号的迷之存在，弹道和敌人一起陷入混乱。': '물음표투성이 수수께끼. 탄도도 적도 함께 혼란에 빠진다.',
  '热血应援团长，环绕子机就是她的啦啦队。': '열혈 응원단장. 궤도 옵션이 그녀의 치어리더.',
  '永远睡不醒的重炮手，醒来的一炮惊天动地。': '영원히 잠이 덜 깬 중포수. 깨어난 한 발은 천지를 뒤흔든다.',
  '卖萌担当，连子弹都是爱你的形状。': '애교 담당. 탄환마저 사랑의 모양.',
  '开心散射': '해피 스프레드',
  '扇形散射，火力提升增加弹道（3→7 向），低速收束': '부채꼴 확산. 화력 상승으로 탄도 증가 (3→7방향), 저속 시 수렴',
  '酷穿双枪': '관통 트윈건',
  '窄直线贯通弹，火力提升追加斜向副炮': '가는 직선 관통탄. 화력 상승으로 사선 부포 추가',
  '怒火三连': '트리플 레이지',
  '贯通火球，火力提升增加弹道（1→5 向），低速合成重击': '관통 화염구. 화력 상승으로 탄도 증가 (1→5방향), 저속 시 중격으로 합체',
  '泪之诱导': '눈물 유도',
  '自动追踪敌人的泪弹，火力提升增加连发数': '적을 자동 추적하는 눈물탄. 화력 상승으로 연발 수 증가',
  '迷惑散射': '혼란 스캐터',
  '随机角度散射，火力提升增加弹数': '랜덤 각도 확산. 화력 상승으로 탄 수 증가',
  '应援直线弹': '응원 스트레이트',
  '直线弹 + 环绕子机，火力提升增加子机数': '직선탄 + 궤도 옵션. 화력 상승으로 옵션 증가',
  '瞌睡重炮': '졸린 캐논',
  '大弹高伤炮，火力提升追加副炮，低速伤害再加成': '대형 고화력포. 화력 상승으로 부포 추가, 저속 시 데미지 추가',
  '爱心扩散': '하트 스프레드',
  '心形扩散弹，火力提升增加弹数': '하트형 확산탄. 화력 상승으로 탄 수 증가',
  '满天烟花': '만개의 불꽃',
  '贯穿主炮': '관통 메인 캐논',
  '以自机为中心的纵激光柱，持续 1.5s': '자기 중심의 세로 레이저 기둥. 1.5초 지속',
  '震爆': '쇼크블라스트',
  '全屏伤敌 + 剧烈震屏 + 清弹': '화면 전체 타격 + 강한 화면 진동 + 탄 소거',
  '泪之护盾': '눈물의 실드',
  '清弹 + 10s 内挡下一次中弹': '탄 소거 + 10초 내 피탄 1회 방어',
  '混乱力场': '혼란 필드',
  '清弹 + 敌机 5s 内射击错乱（射速减半）': '탄 소거 + 적기 사격 5초간 혼란 (연사 절반)',
  '应援结界': '응원 결계',
  '梦境领域': '몽경 영역',
  '大范围清弹 + 敌机睡眠 3s（不射弹）': '넓은 범위 탄 소거 + 적기 3초간 수면 (사격 정지)',
  '爱心爆发': '하트 버스트',
  '无敌冲刺': '무적 대시',
  '2.5s 无敌 + 移速提升 + 接触伤敌': '2.5초 무적 + 이동 속도 상승 + 접촉 타격',
  '子弹时间': '불릿 타임',
  '全场时间 0.35×，持续 2.5s': '전체 시간 0.35배. 2.5초 지속',
  '狂暴': '광폭',
  '大哭': '대성통곡',
  '全力应援': '전력 응원',
  '魅惑': '매혹',
  '屏上敌弹变点道具（上限 200）+ 3s 无敌': '화면의 적탄을 점 아이템으로 (최대 200) + 3초 무적',
  '无敌冲刺！': '무적 대시!',
  '狂暴！！': '광폭!!',
  '护盾展开': '실드 전개',
  '加油！加油！': '파이팅! 파이팅!',
  '云端·天空': '구름 위·천공',
  '深海·水压': '심해·수압',
  '齿轮·机械': '톱니바퀴·기계',
  '腐叶·森林': '썩은 잎·숲',
  '幽影·暗界': '유영·암계',
  '星界·终焉': '성계·종언',
  '终焉回廊': '종언의 회랑',
  'STAGE 1  云端·天空': 'STAGE 1  구름 위·천공',
  'STAGE 2  深海·水压': 'STAGE 2  심해·수압',
  'STAGE 3  齿轮·机械': 'STAGE 3  톱니바퀴·기계',
  'STAGE 4  腐叶·森林': 'STAGE 4  썩은 잎·숲',
  'STAGE 5  幽影·暗界': 'STAGE 5  유영·암계',
  'STAGE 6  星界·终焉': 'STAGE 6  성계·종언',
  'STAGE 1 · 测试关': 'STAGE 1 · 테스트',
  'STAGE 2 · 测试关': 'STAGE 2 · 테스트',
  'STAGE 3 · 测试关': 'STAGE 3 · 테스트',
  'STAGE 4 · 测试关': 'STAGE 4 · 테스트',
  'STAGE 5 · 测试关': 'STAGE 5 · 테스트',
  'STAGE 6 · 测试关': 'STAGE 6 · 테스트',
  '测试关：正式关卡脚本就位后将替换本关': '테스트 스테이지: 정식 스크립트 완성 후 교체',
  '警告：强大的气息接近了……': '경고: 강대한 기운이 다가온다……',
  '第一形态': '제1형태',
  '狂暴形态': '광폭 형태',
  '风暴精灵': '폭풍의 정령',
  '云端的中枢': '구름 위의 중추',
  '积雨云之王': '적란운의 왕',
  '天空的支配者': '천공의 지배자',
  '深海灯笼鱼': '심해 아귀',
  '水压的引路者': '수압의 안내자',
  '深渊克拉肯': '심연의 크라켄',
  '深海的主宰': '심해의 주인',
  '哨戒机': '초계기',
  '齿轮回廊的守卫': '톱니바퀴 회랑의 수호자',
  '核心熔炉': '코어 용광로',
  '机械城的心脏': '기계성의 심장',
  '孢子菇后': '포자 버섯 여왕',
  '腐叶林的女王': '썩은 잎 숲의 여왕',
  '千年树人': '천년 나무 정령',
  '森林的古老意志': '숲의 오래된 의지',
  '提灯鬼': '등불 귀신',
  '暗界的引魂人': '암계의 영혼 안내자',
  '虚无之眼': '허무의 눈',
  '暗界尽头的凝视': '암계 끝의 응시',
  '彗星骑士': '혜성의 기사',
  '星界的先锋': '성계의 선봉',
  '星尘核心': '성진 코어',
  '终焉之核': '종언의 핵',
  '星灵': '별의 정령',
  '终焉回廊的支配者': '종언의 회랑의 지배자',
  '旋风': '선풍',
  '积雨压顶': '적운 압박',
  '雷电走线': '뇌전 배선',
  '诱光': '유인의 빛',
  '触手横扫': '촉수 휩쓸기',
  '墨云': '먹물 구름',
  '触手狂乱': '촉수 광란',
  '警戒扫描': '경계 스캔',
  '齿轮齐射': '톱니바퀴 일제사격',
  '冲压墙': '프레스 벽',
  '蒸汽喷发': '증기 분출',
  '孢子散播': '포자 산포',
  '菌丝缠绕': '균사 휘감기',
  '落叶': '낙엽',
  '花粉风暴': '화분 폭풍',
  '千年之怒': '천년의 분노',
  '鬼火引诱': '도깨비불 유인',
  '奇袭': '기습',
  '凝视': '응시',
  '加速突袭': '가속 돌격',
  '瞳孔收缩': '동공 수축',
  '彗星冲锋': '혜성의 돌진',
  '骑士连击': '기사의 연격',
  '星尘散弹': '성진 산탄',
  '弹幕变换': '탄막 변화',
  '终焉流星雨': '종언의 유성군',
  '乱流': '난기류',
  '暗流': '암류',
  '链齿': '체인 기어',
  '风切': '윈드 시어',
  '云海': '운해',
  '暗涌': '어두운 용솟음',
  '铆钉连射': '리벳 연사',
  '荆棘': '가시',
  '暗雨': '어둠의 비',
  '星尘壁垒': '성진 방벽',
  '风符「旋涡气流」': '풍부「소용돌이 기류」',
  '云符「积雨乱打」': '울부「적우 난타」',
  '岚符「天罚风暴」': '남부「천벌 폭풍」',
  '灯符「深海诱光」': '등부「심해의 유광」',
  '涡符「大漩涡」': '와부「대소용돌이」',
  '泡符「深渊呼吸」': '포부「심연의 호흡」',
  '锁符「回旋封锁」': '쇄부「회선 봉쇄」',
  '链符「定时连锁」': '쇄부「정시 연쇄」',
  '炉符「超临界炉心」': '로부「초임계 노심」',
  '孢符「风媒飞孢」': '포부「풍매 비포」',
  '藤符「封位蔓牢」': '등부「봉위의 만옥」',
  '根符「大地脉动」': '근부「대지의 맥동」',
  '灯符「鬼火提灯」': '등부「도깨비불 등불」',
  '暗符「无光之海」': '암부「무광의 바다」',
  '眼符「虚空凝视」': '안부「허공의 응시」',
  '虚符「虚无降临」': '허부「허무의 강림」',
  '彗符「星尘尾迹」': '혜부「성진의 꼬리」',
  '星符「银河回旋」': '성부「은하의 회선」',
  '核符「超新星爆发」': '핵부「초신성 폭발」',
  '星符「宇宙收缩」': '성부「우주의 수축」',
  '壹符「星屑迎撃」': '일부「성진 영격」',
  '贰符「流星追尾」': '이부「유성 추적」',
  '叁符「十字激光阵」': '삼부「십자 레이저 진」',
  '肆符「曲线回廊」': '사부「곡선의 회랑」',
  '伍符「加速乱舞」': '오부「가속의 난무」',
  '陆符「菌毯蔓延」': '육부「균사 융단의 번식」',
  '柒符「蛇形矩阵」': '칠부「사행 매트릭스」',
  '捌符「终焉·全弹发射」': '팔부「종언·전탄 발사」',
  '飓符「台风眼壁」': '궁부「태풍의 눈 벽」',
  '渊符「深海沉光」': '연부「심해의 침광」',
  '锯符「回旋锯阵」': '거부「회선 톱 진」',
  '茸符「菌毯爆发」': '융부「균융 폭발」',
  '影符「百鬼夜行」': '영부「백귀야행」',
  '陨符「陨星碎击」': '울부「운성의 쇄격」',
  '雷符「轰雷阵」': '뇌부「굉뢰의 진」',
  '旋符「大旋风」': '선부「대선풍」',
  '潮符「怒涛压境」': '조부「노도의 압박」',
  '漩符「螺旋海流」': '선부「나선의 해류」',
  '导符「制导导弹」': '도부「유도 미사일」',
  '齿符「飞散齿轮」': '치부「비산하는 톱니바퀴」',
  '叶符「翠叶旋舞」': '엽부「취엽의 선무」',
  '精符「森之精魄」': '정부「숲의 정혼」',
  '灭符「永夜降临」': '멸부「영야의 강림」',
  '煌符「星火燎原」': '황부「성화요원」',
  '玖符「星链锁阵」': '구부「성쇄의 진」',
  '拾符「终焉·星灵全开」': '십부「종언·성령 전개」',
  '月下的开幕礼': '월하의 개막식',
  '标题画面主题曲': '타이틀 화면 테마',
  '云海散步道': '운해 산책로',
  '第一关·云端主题曲': '1면·구름 위 테마',
  '深蓝摇篮': '심람의 요람',
  '第二关·深海主题曲': '2면·심해 테마',
  '齿轮心脏': '톱니바퀴 심장',
  '第三关·机械主题曲': '3면·기계 테마',
  '光苔之森': '빛이끼의 숲',
  '第四关·森林主题曲': '4면·숲 테마',
  '幽影回廊': '유영의 회랑',
  '第五关·幽影主题曲': '5면·유영 테마',
  '星尘尽头': '성진의 끝',
  '第六关·星界主题曲': '6면·성계 테마',
  '风暴王的仪仗': '폭풍왕의 의장',
  '云端 boss 主题曲': '구름 위 보스 테마',
  '深渊的腕足': '심연의 완족',
  '深海 boss 主题曲': '심해 보스 테마',
  '熔炉核心过载': '용광로 코어 과부하',
  '机械 boss 主题曲': '기계 보스 테마',
  '千年树人的怒号': '천년 나무 정령의 노호',
  '森林 boss 主题曲': '숲 보스 테마',
  '虚无之眼的凝视': '허무의 눈의 응시',
  '幽影 boss 主题曲': '유영 보스 테마',
  '星尘核心崩解': '성진 코어 붕괴',
  '星界 boss 主题曲': '성계 보스 테마',
  '回廊巡礼': '회랑 순례',
  '决战时刻': '결전의 순간',
  '云上凯旋式': '구름 위의 개선식',
  '过关结算结尾曲': '클리어 정산 엔딩',
  '谢幕后的星空': '막을 내린 뒤의 별하늘',
  '制作名单主题曲': '크레딧 테마',
  '标题画面的曲子。全长约 70 秒。C 利底亚调式 96 拍，主旋律交给了马林巴，像八音盒一样一颗一颗地响，底下是弦乐长音和低音提琴拨弦。从第二循环开始，一支长笛带着新的对位旋律加入进来——月亮升起来之后，总得有人陪它说话。写的时候满脑子是「今晚也要出发了」的感觉。': '타이틀 화면의 곡. 약 70초. C 리디안 96BPM, 멜로디는 마림바——오르골처럼 한 음 한 음 울리고, 아래는 현악 롱톤과 콘트라베스 피치카토. 두 번째 루프부터 플루트가 새로운 대위 선율로 합류——달이 뜨면 누군가 말벗이 필요하니까. 쓰는 날남 "오늘 밤도 출발이다"라는 마음이었다.',
  '第一关的曲子。全长约 84 秒，正好陪你跑完一趟云海。D 大调 148，主题交给单簧管，八分泵音拨弦贝斯带着经过音往前跑。曲式是变奏式发展：主题、对比、小高潮、再回到主题，织体一段一段加密，像云一层一层厚起来。小高潮（约 52 秒起）把主题整个抬高一个八度，是穿出云层忽然亮开的一瞬。全程节奏一致、无缝循环；过关的收束句交给了专门的结尾曲。毕竟是第一关，不设防地明亮到底。': '1면의 곡. 약 84초, 운해를 한 번 달리기에 딱. D 장조 148, 테마는 클라리넷, 8분 펌핑 피치카토 베이스가 경과음으로 앞서 달린다. 형식은 변주식 전개: 테마, 대비, 작은 절정, 그리고 테마로 회귀. 구름이 겹치듯 직물이 한층 한층 두꺼워진다. 작은 절정(약 52초~)에서 테마가 통째로 한 옥타브 상승——구름을 뚫고 갑자기 환해지는 순간. 전편 템포 일정의 심리스 루프. 클리어의 수렴은 전용 엔딩곡에 맡겼다. 1면이니까, 방심할 만큼 밝게.',
  '第二关·深海的曲子。全长约 90 秒。A 多利亚调式 96，通篇三连音，摇摇晃晃像被水流推着走。主旋律是长笛——采样里自带的那点颤音，正好是水波的样子。音域收窄了，深海里不需要大起大落。零星的钟琴声是从海面上漏下来的、很远的光。': '2면·심해의 곡. 약 90초. A 도리안 96, 전편 셋잇단음표, 물살에 밀리듯 흔들린다. 멜로디는 플루트——샘플에 담긴 약간의 비브라토가 마침 물결의 모습. 음역은 좁게, 심해엔 큰 기복이 필요 없다. 드문드문한 글로켄슈필은 수면에서 새어 내리오는 먼 빛.',
  '第三关·机械的曲子。全长约 87 秒。E 小调 165，核心是一条短促的切分 ostinato riff，两三个音像齿轮一样反复咬合，小号踩着切分节奏往前冲，底鼓四踩、拨弦贝斯十六分。高潮段 riff 整体抬高八度，流水线换挡提速。请小心不要被卷进去。': '3면·기계의 곡. 약 87초. E 단조 165, 핵심은 짧은 싱코페 오스티나토 리프——두세 음이 톱니바퀴처럼 맞물리고, 트럼펫이 싱코페로 돌진, 킥은 사사지, 피치카토 베이스는 16분. 클라이맥스에서 리프가 한 옥타브 상승, 라인이 기어 체인지. 휘말리지 않도록 조심.',
  '第四关·森林的曲子。全长约 89 秒。G 利底亚调式 118，单簧管加附点节奏，蹦蹦跳跳的，像光斑在苔上跳。贝斯是低音提琴拨弦的 walking，一路经过音，和声用反拍断奏留出空隙给鸟叫（并没有真的录进去）。森林里迷路才是正事，走太快会错过蘑菇。': '4면·숲의 곡. 약 89초. G 리디안 118, 클라리넷에 점음 리듬, 이끼 위의 햇빛 얼룩처럼 깡충깡충. 베이스는 콘트라베스 피치카토 워킹, 경과음 투성이. 화성은 오프비트 스탭으로 새소리(실제로 녹음하진 않았다)에 틈을 남긴다. 숲에서는 길을 잃는 것이 제대로 즐기는 법——서두륩면 버섯을 놓친다.',
  '第五关·幽影的曲子。全长约 87 秒。D 弗里几亚调式的降二级一压下来，走廊就黑了。速度只有 88，音符之间留了很多空白——在这座回廊里，空白比声音更可怕。长笛贴着墙根走路，底鼓放慢成心跳，钟琴每隔一段才敲一下。请当作是为你敲的。': '5면·유영의 곡. 약 87초. D 프리지아의 강 2급이 낮아앉는 순간, 회랑은 어두워진다. 템포는 88뿐, 음과 음 사이에 긴 여백——이 회랑에서는 여백이 소리보다 무섭다. 플루트는 벽가를 걷고, 킥은 심장박동으로 느려지고, 글로켄슈필은 가끔씩만 울린다. 당신을 위해 울리는 것이라 생각해 주길.',
  '第六关·星界的曲子。全长约 88 秒，终点前最后一段路。F# 小调 152，小号吹着长线条的旋律一句一句往上爬，底下是加宽到四个音的弦乐 pad 和 walking 拨弦贝斯，鼓放慢成半步感。小高潮来了两次，第二次更亮。抬头看看，星星都在为你让路。': '6면·성계의 곡. 약 88초, 종점 전 마지막 길. F# 단조 152, 트럼펫이 긴 선율을 한 구절씩 오르고, 아래는 네 음으로 넓힌 현악 pad와 워킹 피치카토 베이스, 드럼은 하프타임 느낌. 작은 절정은 두 번 오고, 두 번째가 더 밝다. 올려다볼라, 별들이 길을 비켜주고 있다.',
  '云端 boss 的曲子。全长约 126 秒，展开→高潮→变奏再现，高潮埋在 36 秒左右。沿用第一关的 D 大调但提到 160，主角从单簧管换成小号——同一座云宫，道中听的是散步曲，王座前吹的是 fanfare。别被排场吓到，弹幕可比这个凶多了。': '구름 위 보스의 곡. 약 126초, 전개→클라이맥스→변주 재현, 절정은 36초 물렵. 1면과 같은 D 장조지만 160으로 가속, 주역은 클라리넷에서 트럼펫으로——같은 구름 궁전이지만, 도중은 산책곡, 옥좌 앞에서는 팡파르. 위엄에 겁먹지 마라, 탄막은 훨씬 더 흉악하다.',
  '深海 boss 的曲子。全长约 130 秒。三连音还在，但从摇篮变成了缠绕——克拉肯的腕足就是这种感觉吧。主旋律交给了长号，从深水底部往上压，鼓换成沉重的三拍连打，高潮在 38 秒附近浮出海面。这次的钟声听起来像沉船的钟。游泳圈请自备。': '심해 보스의 곡. 약 130초. 셋잇단음표는 남지만, 요람에서 휘감김으로——크라켄의 완족이란 그런 것. 멜로디는 트롬본, 심수 바닥에서 밀어 올리고, 드럼은 무거운 삼연타, 클라이맥스는 38초 물렵 해면으로 부상. 이번 종은 침몰선의 종처럼 들린다. 튜브는 지참할 것.',
  '机械 boss 的曲子。全长约 126 秒，175 仍是全曲库最快。切分底鼓加拨弦贝斯的低音脉冲一路碾压，小号是短促的四音呼喊，喊完就走，绝不多留。反拍断奏和双跳军鼓在后面追打，高潮约 38 秒处全线报警。建议在它冷却之前解决战斗。': '기계 보스의 곡. 약 126초, 175는 여전히 전 곡고 최속. 싱코페 킥과 피치카토 베이스의 저역 펄스가 짓누륩며 나아가고, 트럼펫은 짧은 네 음의 함성——외치면 떠난다, 절대 머무르지 않는다. 오프비트 스탭과 더블 스트로크 스네어가 뒤에서 추격, 클라이맥스 약 38초에 전선 경보. 식기 전에 결판을.',
  '森林 boss 的曲子。全长约 128 秒。利底亚的明亮还在，但 142 的速度加反拍断奏，硬是把「散步」变成了「被树根追杀」。单簧管踩着附点节奏，那是树人跺脚的脚步声，钟琴像年轮一样一圈圈荡开。活了千年的东西发火，场面大概就是这样。': '숲 보스의 곡. 약 128초. 리디안의 밝음은 남지만, 142의 속도와 오프비트 스탭으로 "산책"은 "나묿뿌리에 쫓기기"로 바뀐다. 클라리넷이 점음 리듬을 밟는다——그것은 나무 정령의 발구르기, 글로켄슈필은 나이테처럼 퍼진다. 천 년을 산 것이 화나면, 대체로 이런 광경이 된다.',
  '幽影 boss 的曲子。全长约 122 秒。D 弗里几亚继续压暗，速度从关卡的 88 提到 118——那只眼睛盯过来的时候，心跳确实会快这么多。长笛的旋律稀疏得只剩注视，底鼓和军鼓放得很沉，钟琴一下一下，像敲在太阳穴上。别盯着它看太久。': '유영 보스의 곡. 약 122초. D 프리지아는 더욱 어두워지고, 템포는 면의 88에서 118로——그 눈이 이쪽을 볼 때, 심장박동은 분명 그만큼 빨라진다. 플루트 선율은 응시만 남을 만큼 성기어지고, 킥과 스네어는 무겁게 가라앉고, 글로켄슈필은 관자놀이를 치듯 한 번 한 번. 너무 오래 마주 보지 말 것.',
  '最终 boss 的曲子。全长约 131 秒。多主题轮换：A 段全员齐奏断音，像核心外壳一层层碎裂；B 段换成高八度的流动旋律加宽幅弦乐 pad，八分对位像星图一样铺开。168 的速度、双主题的排场，高潮约 40 秒处核心开始崩解。打到这里的人，请把这首当作饯别礼。': '최종 보스의 곡. 약 131초. 다테마 순환: A단은 전원의 스타카토, 코어의 껍질이 층층이 갈라지는 듯; B단은 높은 옥타브의 유려한 선율에 넓은 현악 pad, 8분 대위가 성도처럼 펼쳐진다. 168의 속도, 쌍테마의 위엄, 클라이맥스 약 40초에 코어가 묶어지기 시작. 여기까지 온 사람에게, 전별의 한 곡을.',
  '额外关「终焉回廊」道中的曲子。全长约 82 秒，正好陪你走到王座门前。与 boss 曲「决战时刻」同用 B 弗里几亚调式——同一座回廊，道中是走向王座的脚步，王座前才是决战。速度压到 140（boss 曲 172），主旋律交给长笛蜿蜒而行，羽管键琴的十六分音像回廊深处不知疲倦的齿轮，远处的钟声一下一下，数着你还剩多少路。高潮埋在 41 秒左右，然后留一点空白——门就要开了。': '추가 스테이지「종언의 회랑」도중의 곡. 약 82초, 옥좌의 문까지 딱 맞는 길이. 보스곡 「결전의 순간」과 같은 B 프리지아——같은 회랑, 도중은 옥좌로 향하는 발소리, 그 다음이 결전. 템포는 140으로 낮추고(보스곡은 172), 멜로디는 플루트가 구불구불, 하프시코드의 16분음은 회랑 깊은 곳의 지치지 않는 톱니바퀴, 먼 종소리가 남은 길을 센다. 클라이맥스는 41초 물렵, 그리고 약간의 여백——문이 열린다.',
  '额外关「终焉回廊」的主题曲，全长约 128 秒，写给单关 10 符卡连战的长夜。B 弗里几亚调式 172，小号加八分琶音，紧张感像公式一样叠满，展开→高潮→再现一座三连。曾经是通用 boss 兜底曲，如今转正为 Extra 专用——没有续关的回廊里，它就是唯一的仪仗。': '추가 스테이지「종언의 회랑」의 테마, 약 128초, 단일 면 10 스펠카드 연전의 긴 밤을 위해. B 프리지아 172, 트럼펫에 8분 아르페지오, 긴장이 공식처럼 쌓인다, 전개→클리맥스→재현의 삼연. 한때는 범용 보스 대타곡, 이제는 Extra 전용으로 승격——컨티뉴 없는 회랑에서, 유일한 의장.',
  '过关结算时播放的结尾曲，全长约 10 秒，不循环，播完即止。D 大调 200，小号吹一句上行的 fanfare（I-IV-V-I 一路往上推），长音收束时弦乐对位和钟琴星点一起落下来。loop 曲目全程不再放慢——收束这件事，交给这首专门的曲子来做。': '클리어 정산에서 흐르는 엔딩곡, 약 10초, 루프 없이 한 번만. D 장조 200, 트럼펫이 상행 팡파르(I-IV-V-I로 치달음), 롱톤에 가라앉을 때 현악 대위와 글로켄슈필 별조각이 함께 내린다. 루프곡은 이제 끝에서 느려지지 않는다——수렴은 이 전용곡의 몫.',
  '制作名单场景的曲子，全长约 70 秒，为滚动的名字们而作。C 大调 96，长笛吹着长线条的旋律，弦乐 pad 铺底，鼓只留一点心跳似的脉冲，钟琴远远地敲。曲式走主题、对比、再回主题，结尾四句自然放慢收束——这首不作紧张 loop 用，慢一点没关系。仗打完了，该坐下来看看星星，顺便看看都是谁陪你打了这一仗。': '크레딧 화면의 곡, 약 70초, 흘러가는 이름들을 위해. C 장조 96, 플루트가 긴 선율을 노래하고, 현악 pad가 깔리고, 드럼은 심장박동 같은 펄스만, 글로켄슈필은 멀리서 울린다. 형식은 테마, 대비, 테마 회귀, 마지막 네 마디는 자연스럽게 느려지며 가라앉는다——긴장된 루프용이 아니니, 천천히 합도 괜찮다. 싸움은 끝났다. 앉아서 별을 보자, 누가 함께 싸워줬는지도, 겸사겸사.',

  "我绕着自己打转，风就跟着我打转——一会儿左旋，一会儿右旋。看傻了可不行，涡流会把你一起卷进去的哦。": "내가 빙글빙글 돌면, 바람도 따라서 돌아——한참 왼쪽, 그다음 오른쪽. 멍하니 볼 때가 아니야, 소용돌이에 같이 휘말릴 테니까.",
  "台风里最安全的地方是风眼。我把风墙转着压过去，只给你留一个口——敢不敢钻进来，和我面对面？": "태풍에서 제일 안전한 곳은 눈이야. 벽을 돌리며 몰려오니 틈은 딱 하나——뛰어들어서 나와 마주 볼 용기 있어?",
  "云越积越厚，雨越下越急。我的积雨云从来不一次下完，它喜欢先试探，再倾盆。": "구름은 쌓일수록, 비는 거세져. 내 적란운은 한 번에 쏟지 않아. 먼저 시험하고, 그다음 퍼붓는 거지.",
  "旋臂、花瓣、暴雨一齐上场的时候，连我自己都要让三分。这是天空的全力，你姑且当作天罚来躲吧。": "선회 팔에 꽃잎, 폭우까지 전부 투입——나조차 살짝 비켜설 정도야. 하늘의 전력이니, 천벌이라 생각하고 피하렴.",
  "雷不劈同一个地方？那是凡人的雷。我的落雷专挑你站的地方劈，半路还会拐弯。": "번개는 같은 곳에 안 떨어진다고? 그건 인간의 번개야. 내 낙뢰는 네가 선 자리를 노리고, 중간에 꺾이지.",
  "暴风雨的终曲是一支圆舞。风往哪边转，雨就往哪边倒——跟上节拍，或者被我卷走。": "폭풍의 피날레는 윤무곡. 바람이 도는 쪽으로 비도 쓰러져——박자를 타든가, 휩쓸리든가.",
  "深海里没有光，除了我这一盏。灯火明明灭灭地飘过来，跟着光走的孩子，最后都到我嘴里来了。": "심해에는 빛이 없어, 내 등불 하나 빼고는. 깜빡이며 떠오는 불빛을 따라온 아이는, 전부 내 입속으로 들어왔지.",
  "沉下去的光是什么样子？大颗大颗，慢慢地开，像花在墨里绽。卷流会替我推你一把，别客气。": "가라앉은 빛은 어떤 모습일까? 큰 알갱이가 천천히 피어나는, 먹물 속의 꽃처럼. 물살이 등을 밀어줄 테니, 사양 말고.",
  "我的腕足搅一搅，海就转起来了。卷向说变就变——海流听我的，不听你的。": "완족으로 한번 휘저으면, 바다가 돌기 시작해. 도는 방향은 변덕——해류는 네 말이 아니라 내 말을 듣거든.",
  "深渊也会呼吸。一呼一吸，花都跟着涨落。你屏住呼吸没用，它又不听你的。": "심연도 숨을 쉬어. 들숨, 날숨——꽃이 그에 맞춰 피고 져. 네가 숨을 참아도 소용없어, 안 따라주니까.",
  "浪一排一排压过来，缺口换来换去。被追上的话，就当我给你一个拥抱吧——用八条腕足。": "파도가 한 줄 또 한 줄 밀려오고, 빠져나갈 곳은 그때마다 바뀌어. 잡히면, 여덟 다리로 포옹해 줄게.",
  "见过大漩涡长出骨架的样子吗？旋臂是骨，卷流是肉。这张网撒出去，连我自己都收不回来。": "소용돌이에 골격이 돋은 걸 본 적 있어? 나선 팔이 뼈, 물살이 살. 이 그물을 던지면, 나조차 거둘 수 없어.",
  "警告：本机封锁光束每五秒换向一次。规避窗口已计算完毕——不会告诉你的，自己算。": "경고: 본 기기의 봉쇄 빔은 5초마다 반전됩니다. 회피 윈도는 계산 완료——알려주지 않습니다. 직접 계산하세요.",
  "锯片臂数：三、四、五。转速：呼吸变速。警告：本机不对被切割者的体验负责。": "톱 아머 수: 셋, 넷, 다섯. 회전: 호흡 변속. 경고: 본 기기는 절단된 측의 체험에 책임지지 않습니다.",
  "听，咔、咔——停。齿轮咬两扣，歇一口气。这就是我心跳的声音，你跟得上吗？": "들어봐, 딸깍, 딸깍——정지. 톱니는 두 번 물리고 한숨 쉬어. 이게 내 심장 소리야. 따라올 수 있어?",
  "温度上来了！旋臂越转越快，脉冲一圈比一圈密。炉心过载之前，要么你先退，要么我炸给你看。": "온도 상승! 나선 팔은 빨라지고, 맥동하는 고리는 촘촘해져. 노심이 과부하되기 전에——물러나든가, 폭발을 보든가.",
  "导弹一旦锁定，只会越咬越死，甩是甩不掉的。唯一的办法是别站着不动——虽然是废话。": "미사일은 한번 록온하면 점점 깊이 물어뜯어. 떨쳐낼 수 없어. 계속 움직이는 수밖에——당연하지만.",
  "大齿轮小齿轮一起甩出去，离心力把它们掰成弯的。流水线嘛，偶尔也出点飞件。": "큰 톱니도 작은 톱니도 한꺼번에 던져서, 원심력으로 휘게 해. 라인에도 가끔은 튀어나오는 부품이 있는 법이야.",
  "我的孩子们乘风去旅行，落在哪儿，就在哪儿住下。你也当心，别让它们落在你身上。": "내 아이들은 바람을 타고 여행해서, 떨어진 곳에 뿌리내리지. 너도 조심해——네 위에 떨어지지 않게.",
  "菌毯醒来的时候，花一丛一丛地开，孢子像雨一样落。踩过我的地毯，总要付出点代价。": "균사가 깨어날 때, 꽃은 곳곳에서 피고 포자는 비처럼 내려. 내 카펫을 밟았으면, 대가를 치러야지.",
  "藤蔓不急。它先围起来，再把缺口一个个挪开。一千年了，没有谁跑得过耐心。": "덩굴은 서두르지 않아. 먼저 둘러싸고, 빠져나갈 곳을 하나씩 옮기지. 천 년 동안, 인내를 이긴 자는 없었어.",
  "把手放在地上，你摸到的就是它的脉。一胀，一缩。我的根，比你想象的走得远。": "대지에 손을 얹어 봐——그 맥박이 나야. 부풀고, 오그라들고. 뿌리는 생각보다 멀리까지 뻗어 있어.",
  "落叶也会跳舞，转够了就换个方向。年轻人，别光看叶子好看——舞池里是不能停脚的。": "낙엽도 춤을 춰, 한 바퀴 돌면 방향을 바꿔서. 젊은이, 잎사귀에 넋 빼지 말고——무도장에서 멈춰 서면 안 돼.",
  "林子里的小东西喜欢你，会一直跟着你。花开了又谢，谢了又开——它们可不懂什么叫客气。": "숲의 작은 아이들은 널 좋아해서, 계속 따라다닐 거야. 꽃은 피었다 지고, 졌다 피고——예의라는 걸 몰라.",
  "提灯一晃，鬼火就飘过去了。忽明忽暗，才是引路的样子嘛。跟紧哦——跟丢了可不怪我。": "랜턴을 한번 흔들면, 도깨비불이 떠가지. 깜빡여야 길 안내답잖아. 잘 따라와——길 잃어도 난 몰라.",
  "夜行的队伍出发咯。小鬼火三三两两地走，走得慢的可别掉队。哎呀，你也在队伍里吗？": "밤의 행렬, 출발이야. 작은 도깨비불이 두셋씩 나란히 걸어가. 늦어지는 애는 버려둬. 어라, 너도 행렬에 있니?",
  "海没有光，一波一波地涨。你在里面能看见什么？什么都看不见，除了我在看你。": "빛 없는 바다, 한 물결 또 한 물결 차오르지. 그 안에서 뭐가 보여? 아무것도——내가 널 보고 있는 것 빼고는.",
  "被盯着的东西会越转越快。我的视线不拐弯，我的弹幕会。眨眼，就算你输。": "응시당하는 것은 점점 빨리 돌아. 내 시선은 꺾이지 않아. 하지만 탄막은 꺾이지. 눈 깜빡이면, 네 패배.",
  "紫色，蓝色，紫色，蓝色。虚无没有颜色，所以什么颜色都可以是。沉进去吧。": "보라, 파랑, 보라, 파랑. 허무엔 색이 없으니, 어떤 색이든 좋아. 가라앉으렴.",
  "夜落下来的时候，连弹幕都会被压弯。换个方向，再压一次。永夜的意思就是：不会天亮。": "밤이 내리면, 탄막조차 눌려 휘어. 방향을 바꿔, 한 번 더. 영야란——밝지 않는 밤이라는 뜻이야.",
  "彗星过境，尾迹会留下来陪你玩。小心，它们还会在半空碎成星尘——优雅，但是危险。": "혜성이 지나가면, 꼬리 자국이 남아 놀아줘. 조심해, 공중에서 별티끌로 부서지니까——우아하지만, 위험해.",
  "正面接下我的陨星雨吧！砸下来还不算完，碎了还要再追你一段。骑士的问候，从来不只一下。": "운석 비를 정면으로 받아 봐! 떨어지고 끝이 아니야, 부서져서 한참 더 쫓아와. 기사의 인사는 한 번으로 끝나지 않아.",
  "银河就这样转了一百亿年，快一阵，慢一阵。你倒是第一个想从旋臂里穿过去的。": "은하는 이렇게 백 억 년을 돌아왔어, 빨라졌다 느려졌다. 나선 팔을 빠져나가려 한 건, 네가 처음이야.",
  "恒星燃尽的时候会换一种颜色，再换一种颜色。看好了——这是我最亮的样子。": "타버린 별은 색을 바꾸고, 또 바꿔. 잘 봐——이게 가장 밝은 나야.",
  "宇宙到最后会往回收。反着转，缩着走，所有花样一起来。能见证这一幕，你运气不错。": "우주는 마지막에 안으로 수축해. 역회전, 줄어드는 고리, 전부 투입. 목격할 수 있어서, 운이 좋네.",
  "一点星火，被热浪卷成环，碎开来就是一片原。燃烧这种事，我最懂了。": "불티 하나가 열파에 고리로 말리고, 부서져 들불이 돼. 태우는 일이라면, 내가 제일 잘 알지.",
  "回廊的规矩第一条：先接住星屑。旋臂转着，礼花开着——欢迎来到终焉回廊。": "회랑의 규칙 첫째: 먼저 별티끌을 받아내. 나선 팔이 돌고, 축포가 피고——종언의 회랑에 어서 와.",
  "流星一旦认出你，就会一直追。追上之前，还会在半空开花。被星星喜欢，是要付出代价的。": "유성은 널 알아본다면 계속 쫓아와. 따라잡기 전에, 공중에서 꽃이 피지. 별의 사랑을 받으려면 대가가 필요해.",
  "十字封场，来回地扫。回廊里没有死角，只有还没扫到的地方。": "십자로 봉하고, 왕복으로 쓸어. 회랑에 사각은 없어——아직 쓸리지 않은 곳이 있을 뿐.",
  "直来直去的回廊多没意思。我把它卷起来——墙还是那堵墙，路可不是那条路了。": "곧은 회랑은 심심하잖아. 말아 올려버려——벽은 그대로지만, 길은 이미 다른 길.",
  "舞会开始了。灯球转着，舞步越跳越快。踩错一拍？那就当给我助兴了。": "무도회 시작이야. 미러볼이 돌고, 스텝은 점점 빨라져. 박자를 놓쳤다고? 그럼 나를 위한 여흥으로.",
  "借来的地毯，意外地好用。孢子在回廊里扎了根，一圈一圈地等你。——谢啦，菇后。": "빌려 온 카펫, 의외로 쓸만해. 포자가 회랑에 뿌리내려, 고리가 되어 기다려.——고마워, 버섯 여왕.",
  "蛇会走直线吗？矩阵会扭吗？在我这里都会。扭的幅度嘛，看我心情。": "뱀이 직진할 수 있을까? 매트릭스가 꿈틀댈까? 여기선 둘 다 꿈틀대. 꿈틀거리는 폭은, 내 기분 나름.",
  "终焉第一幕：全弹发射。青的紫的一起来，转够八秒换一边。撑住，这才刚开始。": "종언 제1막: 전탄 발사. 청록과 보라가 함께, 8초마다 반전. 버텨——이제 겨우 시작이야.",
  "星链一扣一扣地锁，墙一排一排地围。咔、咔——停。你猜，下一扣锁在哪里？": "별사슬은 한 고리씩, 벽은 한 줄씩. 딸깍, 딸깍——정지. 자, 다음 고리는 어디에 떨어질까?",
  "最后一幕，星灵全开。花按彩虹的顺序开，蛇形按着呼吸扭。过了这关，回廊就没有秘密了。": "최종막, 성령 전개. 꽃은 무지개 순서로 피고, 뱀은 호흡에 맞춰 꿈틀대. 이걸 뚫으면, 회랑에 비밀은 없어.",

  "何人在寡人的云海踏浪？风都替你紧张起来了。": "누구냐, 나의 운해에서 파도를 타는 자는? 바람도 널 걱정하는구나.",
  "我叫开开心！借你的云打个招呼——弹幕，来啦！": "나는 카이카이! 구름 좀 빌려서 인사할게——탄막, 간다!",
  "过路。让开。": "지나가는 길. 비켜.",
  "挡路的？正好，我手痒了！": "길 막는 거야? 마침 손이 근질근질했어!",
  "那、那个……我只是路过……呜……": "저、저기…… 그냥 지나가는데…… 우웅……",
  "咦？云……成精了？": "어? 구름이…… 살아났어?",
  "路过顺便给你加个油——然后打一架！": "지나가다 응원해 줄게——그리고 한 판 붙자!",
  "唔……好软的云……能睡个午觉吗……": "음…… 폭신한 구름…… 낮잠 자도 돼……?",
  "萌萌路过~大个子你会比心吗？": "모에가 지나갈게~ 큰 분, 하트 만들 줄 알아?",
  "只是路过的弹幕使。借过。": "그냥 지나가는 탄막사야. 실례.",
  "借过？云海没有路，只有风向。逆着寡人的风，半步也休想。": "실례라고? 운해엔 길이 없고 바람만 있느니라. 내 바람을 거슬러선 반 발자국도 못 간다.",
  "那我就顺着你的风跳个舞给你看！": "그럼 그 바람을 타고 춤을 보여줄게!",
  "风会停。你不会赢。": "바람은 멈춰. 넌 못 이겨.",
  "我把你的风全打回去！": "그 바람, 전부 되돌려줄게!",
  "对不起对不起……但、但是我不能退……！": "미、미안…… 하、하지만 물러날 수 없어……!",
  "风……往哪边吹来着？": "바람이…… 어느 쪽으로 불더라?",
  "风向什么的，看我的气势把它吹回去！": "바람 방향이고 뭐고, 기합으로 되돌려버리겠어!",
  "逆风……好困……快点打完吧……": "맞바람…… 졸려…… 빨리 끝내자……",
  "风再大，也吹不走我的可爱~": "아무리 강한 바람도 내 귀여움은 못 날려~",
  "那我只好自己开一条路了。": "그럼 내 길은 내가 뚫는 수밖에.",
  "好胆色。那就让积雨云看看——你能接住几滴天罚。": "배짱 좋네. 그럼 적란운에게 보여줘라——천벌의 빗방울을 몇 방울이나 받아낼 수 있을지.",
  "水面上的客人……是灯的甜味引你下来的吗？": "수면 위의 손님…… 등불의 달콤함에 이끌려 낮아온 거니?",
  "是你的派对灯光太好看啦！带我一个！": "파티 조명이 너무 예뻐! 나도 끼워줘!",
  "你的灯，太晃眼。": "그 등불, 너무 눈부셔.",
  "少废话！上来就打！": "잔말 말고! 덤벼!",
  "呜……这里好黑……你的灯可以借我一下吗……": "우웅…… 여기 너무 어두워…… 등불 좀 빌려줄래……?",
  "咦，是你约我下来的吗？": "어, 네가 날 초대한 거야?",
  "深海巡游第一站！克拉肯，接招！": "심해 투어 첫 정거장! 크라켄, 받아라!",
  "水里好舒服……想边睡边打……": "물속 편안해…… 자면서 싸울래……",
  "哇，八条腿！可以帮我扎头发吗？": "와, 여덟 다리! 머리 땋아줄 수 있어?",
  "我只是追着弹幕的轨迹下来的。": "탄막 궤적만 따라 낮아진 거야.",
  "深海没有甜，只有压。你的骨头会先替我尝到。": "심해엔 달콤함이 없고 압력만 있지. 네 뼈가 먼저 맛보게 될 거야.",
  "压强什么的，笑着就顶住啦！": "수압쯤이야, 웃으며 버텨보일게!",
  "我的枪比你的压更重。": "내 총은 네 압력보다 무거워.",
  "看我把你煮成章鱼烧！": "타코야키로 삶아먹어 줄게!",
  "骨、骨头会断掉吗……好可怕……但我不走！": "뼈、뼈가 부러질까……? 무서워…… 하지만 안 물러나!",
  "压？是哪一种压？": "압력? 어느 쪽 압력?",
  "我的热血，深海也煮得沸！": "내 열혈은 심핏도 끓게 만들어!",
  "压一压……更好睡……": "눌러주면…… 더 잘 자……",
  "压力讨厌~萌萌要浮起来！": "압력은 싫어~ 모에는 떠오를래!",
  "那就比比谁先被压垮。": "그럼 누가 먼저 으깨지나 겨뤄보자.",
  "有趣。腕足已张开——这场拥抱，你躲不掉。": "흥미롭군. 완족은 벌렸다——이 포옹은 못 피해.",
  "警告：核心区域，非授权单位。立即停机，接受熔解。": "경고: 코어 구역, 미인가 유닛. 즉시 정지하고 용융을 받아들여라.",
  "拒绝停机！我还要去玩呢！": "정지 거부! 아직 놀러 갈 거야!",
  "授权？我就是。": "인가? 그게 나야.",
  "熔解？！我先把你拆了卖废铁！": "용융?! 먼저 해체해서 고철로 팔아줄게!",
  "对、对不起，我这就走……咦，走不掉？": "미、미안, 바로 나갈게…… 어, 못 나가?",
  "停机……是按哪个钮？": "정지…… 어느 버튼이야?",
  "检测报告：你这炉子火力不足！": "검사 보고: 이 용광로, 화력 부족!",
  "停机……好耶……那我可以睡了吗……": "정지…… 좋아…… 그럼 자도 돼……?",
  "熔解好可怕~萌萌会化掉的！": "용융 무서워~ 모에가 녹아버려!",
  "我只是借道的，不打算停机。": "그냥 지나가는 길이야. 정지할 생각 없어.",
  "借道申请驳回。本炉每分钟熔解借道单位十二个。": "통과 신청 기각. 본로는 통과 유닛을 분당 열한 개 용융한다.",
  "那我做第十三个——特别难熔的那种！": "그럼 내가 열세 번째가 될게——특별히 안 녹는 종류로!",
  "你的产量，今天归零。": "그 생산량, 오늘 제로가 된다.",
  "才十二个？我一个顶一百个！": "겨우 열한 개? 나는 백 개 몫이야!",
  "呜……我不想被熔解……我要回家……": "우웅…… 녹기 싫어…… 집에 가고 싶어……",
  "十二个……那第十三个免费吗？": "열한 개…… 열세 번째는 공짜야?",
  "熔解之前，先尝尝我的热血！": "녹이기 전에 내 열혈부터 맛봐!",
  "十二个……数着数着就困了……": "열한 개…… 세다 보니 졸려……",
  "驳回无效~萌萌的票是永久的！": "기각 무효~ 모에의 티켓은 영구 유효!",
  "那今天这个数字到你为止。": "그럼 오늘 그 숫자는 너로 끝이다.",
  "炉心升温。链齿咬合——开始熔解程序。": "노심 가열. 기어 맞물림——용융 프로토콜 개시.",
  "慢些。再慢些。你听，腐叶下面，都是千年的根。": "천천히. 더 천천히. 들어봐, 썩은 잎 아래, 천 년의 뿌리들이야.",
  "树爷爷好！你的叶子我能捡一片吗？": "나무 할아버지 안녕! 잎사귀 한 장 주울 수 있을까?",
  "让路，老树。": "비켜, 늙은 나무.",
  "千年？烧掉只要十分钟！": "천 년? 태우는 건 10분이면 돼!",
  "对、对不起……我踩疼你的根了吗……": "미、미안…… 뿌리 아프게 밟았어……?",
  "根……在跟我说话？": "뿌리가…… 나한테 말하는 거야?",
  "千年古树！值得我全力一战！": "천 년 고목! 전력으로 싸울 가치가 있어!",
  "千年……那你一定很困吧……": "천 년…… 그럼 많이 졸리겠네……",
  "树爷爷，萌萌可以在这里野餐吗？": "나무 할아버지, 모에 여기서 피크닉해도 돼?",
  "久仰。我只是路过的客人。": "존경해. 그냥 지나가는 손님이야.",
  "客人踩断了三根细根。千年了，我学会的第一课，就是不再原谅。": "손님이 가는 뿌리 세 개를 꺾었다. 천 년을 살으며 처음 배운 것은, 용서를 멈추는 법이었다.",
  "那我赔你一场热闹！森林最喜欢热闹了！": "그럼 떠들썩함으로 갚을게! 숲은 떠들썩한 걸 좋아해!",
  "我数着的。两根。": "세고 있었어. 두 개.",
  "才三根？我让你断三千根！": "겨우 세 개? 삼천 개를 꺾어줄게!",
  "呜哇——对不起！我、我给你浇水！": "우와아——미안! 물、물 줄게!",
  "三根……是左边那三根吗？": "세 개…… 왼쪽 세 개?",
  "那我用全力道歉——全力一战！": "그럼 전력으로 사과할게——전력의 한 판으로!",
  "原谅我嘛……我只是想睡觉……": "용서해줘…… 그냥 낮잠 자고 싶었을 뿐이야……",
  "萌萌这么轻，怎么会断呢~？": "모에는 가벼울걸, 꺾일 리 없잖아~?",
  "那我只好用胜利道歉了。": "그럼 승리로 사과할 수밖에.",
  "藤蔓不急。它有一整个下午，把你留在这里。": "덩굴은 서두르지 않아. 오후 종일 널 여기 붙잡아 둘 거야.",
  "你看得见我吗？这里很暗。暗到只剩我在看你。": "내가 보이니? 여긴 어두워. 내가 보고 있다는 것만 남을 만큼.",
  "看得见呀！这么大一只眼睛，想看不见都难！": "보여! 이렇게 큰 눈은 안 보이는 게 더 어렵지!",
  "看够了就闭眼。": "실컷 봤으면 감아.",
  "看什么看！把你打成瞎子！": "뭘 쳐다봐! 장님으로 만들어주겠어!",
  "呜……被盯着看……好可怕……": "우웅…… 쳐다봄당하고 있어…… 무서워……",
  "咦，是谁在说话？": "어, 누가 말하는 거야?",
  "那就看看我的光！亮瞎你！": "그럼 내 빛을 봐! 눈부셔서 눈 멀 거야!",
  "黑黑的……正好睡觉……": "어두워…… 자기 딱 좋네……",
  "萌萌这么可爱，看个够吧~": "모에는 귀여우니까, 실컷 봐도 돼~",
  "彼此彼此。": "피차일반이지.",
  "每个进来的人都这么说。他们最后都把眼睛留在了这里。": "들어오는 자는 다들 그렇게 말했지. 마지막엔 전부 눈을 여기 두고 갔다.",
  "眼睛才不给你！我还要用它看明天的太阳！": "눈은 안 줄 거야! 내일의 태양을 봐야 하거든!",
  "试试。": "해봐.",
  "我把你的眼睛挖出来陪葬！": "그 눈을 파내서 부장품으로 삼아줄게!",
  "不、不要！我的眼睛还要留着哭……": "시、싫어! 내 눈은 울기 위해서도 필요해……",
  "留眼睛……怎么留？": "눈을 두고 간다는 게…… 어떻게?",
  "我的视线是燃着的——拿不住！": "내 시선은 불타고 있어——못 잡아!",
  "眼睛给你……眼皮给我留下……": "눈알은 줄게…… 눈꺼풀만 남겨줘……",
  "不给~萌萌要眼睛来卖萌的！": "못 줘~ 모에는 그 눈으로 애교 부려야 해!",
  "你留不住我的。": "내 건 못 가져.",
  "那现在，换我仔细看看你——别眨眼。": "그럼 이제 내가 자세히 볼 차례——눈 깜빡이지 마.",
  "旅人，你走到了星屑的尽头。再往前，就是终焉。": "나그네여, 별티끌의 끝에 닿았구나. 저 너머는 종언이다.",
  "终焉？听起来像最后一关！那我更要冲了！": "종언? 마지막 스테이지잖아! 더 돌격해야지!",
  "终焉见多了。让开。": "종언은 많이 봤어. 비켜.",
  "终焉？！我先把你终焉了！": "종언?! 너부터 종언시켜주겠어!",
  "终、终焉……听起来好可怕……但我不能回头……": "종、종언…… 무서워 보여…… 하지만 돌아갈 수 없어……",
  "咦？这里就是最后一关吗？": "어? 여기가 마지막 스테이지야?",
  "燃烧到星屑的尽头——正合我意！": "별티끌 끝까지 불태운다——딱 내 취향!",
  "终焉……打完就能睡了吧……": "종언…… 잡으면 잘 수 있는 거지……?",
  "终焉是什么？能吃吗？": "종언이 뭐야? 먹을 수 있어?",
  "那就把终焉变成我的终点线。": "그럼 그 종언을 내 결승선으로 만들어주겠어.",
  "星尘核心的每一次脉动，都是一个世界的余烬。你要以肉身贴近它？": "성진 코어의 고동 하나하나가 세계의 잔불이야. 맨몸으로 가까이 갈 셈이야?",
  "余烬也是光呀！我来替你点亮下一把火！": "잔불도 빛이야! 다음 불을 점화해 줄게!",
  "我贴近过的核心，不止你一个。": "가까이 간 코어는 너뿐이 아니야.",
  "脉动？打爆了就不脉了！": "고동? 날려버리면 멈춰!",
  "余、余烬会烫吗……呜……但我不会退！": "잔、잔불은 뜨거워……? 우웅…… 하지만 안 물러나!",
  "贴近？多远算贴近？": "가깝다는 게, 어느 정도?",
  "我的血也是余烬燃的！比比谁烫！": "내 피도 잔불로 타고 있어! 누가 더 뜨거운지 겨뤄보자!",
  "余烬……暖烘烘的……适合睡觉……": "잔불…… 따끈따끈…… 자기 좋네……",
  "余烬也要萌萌地烧！": "잔불도 모에답게 태워!",
  "贴近了，才能打穿它。": "가까이 가야 관통할 수 있어.",
  "那么——银河回旋，为你让路。前提是，你过得去。": "그럼——은하의 회전, 길을 비켜주지. 지나갈 수 있다면 말이야.",
  "回廊的考官见过许多来客。走到王座前的，你是第一个。": "회랑의 시험관은 많은 손님을 봐왔다. 옥좌까지 닿은 자는, 네가 처음이다.",
  "第一个？那我要拿满分！": "처음? 그럼 만점 받을래!",
  "考官？我只带枪来。": "시험관? 나는 총만 가져왔어.",
  "少摆架子！你的题我全拆了！": "거들먹거리지 마! 문제 전부 부숴줄게!",
  "考、考试？我没复习……呜……": "시、시험? 공부 안 했는데…… 우웅……",
  "咦？要考试吗？考什么？": "어? 시험? 무슨 시험?",
  "毕业考是吧！看我的热血答卷！": "졸업시험이지! 내 열혈 답안을 봐!",
  "考完……就能睡了吧……": "시험 끝나면…… 잘 수 있는 거지……?",
  "考官老师~可以开卷吗？": "선생님~ 오픈북 돼요?",
  "第一个，但不会是最后一个。": "처음이지만, 마지막은 아니야.",
  "十道符卡，没有续关。答错一题，就留在回廊里当星屑。": "스펠카드 열 문제, 컨티뉴 없음. 한 문제 틀리면, 회랑의 별티끌이 된다.",
  "十道全对！星屑还是留给你自己吧！": "열 문제 전부 정답! 별티끌은 네가 가져!",
  "出题吧。": "문제 내봐.",
  "一题都不会错！错了我把回廊烧了！": "한 문제도 안 틀려! 틀리면 회랑을 불태울게!",
  "不、不要当星屑……我要回家……": "별、별티끌 되기 싫어…… 집에 가고 싶어……",
  "星屑……和星星是亲戚吗？": "별티끌은…… 별이랑 친척이야?",
  "十道而已！我的热血够答一百道！": "겨우 열 문제! 내 열혈은 백 문제도 풀어!",
  "十道……数着数着就困了……": "열 문제…… 세다 보니 졸려……",
  "萌萌的答案都是满分答案~": "모에의 답은 전부 만점이야~",
  "那就一题一题打过去。": "그럼 한 문제씩 쓰러뜨려 가겠어.",
  "很好。终焉回廊，开考。": "좋다. 종언의 회랑, 개시.",

  "环波 3 波 + 每波 10 向子机齐射": "링 웨이브 3연 + 매 웨이브 10방향 옵션 일제사격",
  "2 波心形追踪弹（每波 6 颗）锁定敌人": "하트 유도탄 2웨이브(각 6발), 적을 조준",
  "思维混乱": "사고 혼란",
  "4s 内屏上敌弹方向错乱（随机摆动）": "4초간 적탄이 방향을 잃는다(랜덤 흔들림)",
  "全屏敌弹 50% 变成点道具（上限 300 颗）": "전 화면의 적탄 50%를 포인트 아이템으로(최대 300개)",
  "0.8s 无敌并向前瞬移一段距离": "0.8초 무적 + 전방으로 순간이동",
  "睡遁": "수면 둔주",
  "6s 射速×1.6、伤害×1.3": "6초간 연사력 ×1.6, 데미지 ×1.3",
  "8s 子机火力×2 + 自机移速×1.15": "8초간 옵션 화력 ×2 + 기체 이동속도 ×1.15",
  "诶…？": "어…？",

  "2s 连环分区爆破：每爆清一区并伤敌（伪全屏）": "2초 연쇄 구역 폭파: 폭파마다 한 구역을 정리하고 피해(유사 전면)",

  "额外关·终焉回廊": "추가 스테이지「종언의 회랑」",
  "额外关  终焉回廊": "추가 스테이지  종언의 회랑",
  "额外关 CLEAR!!": "추가 CLEAR!!",
  "额外关道中主题曲": "추가 스테이지 도중 테마",
  "额外关 boss 主题曲": "추가 스테이지 보스 테마",

};
